<script>
    import {url} from "@sveltech/routify";
    import {goto} from '@sveltech/routify';
    import {_} from 'svelte-i18n';
    import Spinner from "../../components/spinner/Spinner.svelte";

    import {authenticate} from '../../auth-store';
    import {getContext} from "svelte";

    const MyAnalytics = getContext('MyAnalytics');
    let auth = [];

    let activeErrorMessage = '';
    let isProcessing = false;

    let email;
    let password;

    const login = async () => {
        isProcessing = true;

        activeErrorMessage = '';

        let formData = new FormData();
        formData.append('client_id', 'API_CLIENT_ID');
        formData.append('client_secret', 'API_CLIENT_SECRET');
        formData.append('grant_type', 'password');
        formData.append('email', email);
        formData.append('password', password);

        try {
            const res = await fetch('API_TOKEN_URL', {
                method: 'POST',
                body: formData,
            });

            auth = await res.json();
        } catch (e) {
            isProcessing = false;
            activeErrorMessage = e;
            return;
        }

        isProcessing = false;

        if (auth.error && auth.error.invalid_grant) {
            activeErrorMessage = auth.error.invalid_grant;
        } else {
            if (!auth.auth.access_token) {
                activeErrorMessage = 'No token received';
            } else {
                authenticate(auth);
                MyAnalytics.setUserId(auth.user.id);
                MyAnalytics.logEvent('login', { method: 'email'});
                $goto('/app/campaigns');
            }
        }
    };

</script>

<div class="card text-center login-card">
    <div class="card-header">
        {$_('page.login.loginTitle')}
    </div>
    <div class="card-body">

        {#if isProcessing}
            <Spinner/>
        {/if}

        {#if activeErrorMessage}
            <div class="alert alert-danger">{activeErrorMessage}</div>
        {/if}

        <form on:submit|preventDefault={login}>
            <div class="form-group">
                <label for="email">{$_('global.email')}</label>
                <input bind:value={email} placeholder={$_('global.email')} id="email" class="form-control">
            </div>
            <div class="form-group">
                <label for="password">{$_('global.password')}</label>
                <input bind:value={password} type="password" id="password" class="form-control">
            </div>
            <div class="form-group">
                <input type="submit" value={$_('page.login.login')} on:click={login} class="btn btn-primary">
            </div>
        </form>
    </div>
</div>

<div class="container">
    <p>{$_('page.login.supportMessage')}</p>
</div>

<div class="card fixed-bottom">
    <div class="card-body">
        <p>If you forgot your password please try to reset it via e-mail:</p>
        <a href={$url('/password/:email', {email: email})}
           class="btn btn-dark btn-sm">{$_('page.login.resetPassword')}</a>
    </div>
</div>


<style>
    p {
        font-size: 12px;
    }

    .login-card {
        margin-bottom: 10px;
    }
</style>